/**
 * Web `ShimmerText` — a highlight that sweeps across a running status label.
 *
 * Implemented with `background-clip: text` (see `.tabbio-shimmer-text` in
 * global.css) rather than by splitting the string into per-character spans.
 * Splitting is the common trick and it breaks Arabic outright: letters lose
 * their joining forms the moment each one becomes its own text run. Clipping a
 * gradient to already-laid-out glyphs leaves shaping untouched in every script.
 */
import type { CSSProperties, FC, HTMLAttributes, ReactNode } from 'react';

export const ShimmerText: FC<
  {
    children: ReactNode;
    /** Off once the step settles — a finished line should sit still. */
    active?: boolean;
    style?: CSSProperties;
    className?: string;
  } & Pick<HTMLAttributes<HTMLSpanElement>, 'role' | 'aria-live' | 'aria-atomic'>
> = ({ children, active = true, style, className, ...aria }) => (
  <span
    dir="auto"
    className={[active ? 'tabbio-shimmer-text' : '', className].filter(Boolean).join(' ')}
    style={style}
    {...aria}
  >
    {children}
  </span>
);

export default ShimmerText;
